import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
const RequireAuth = ({ children, allowedRoles }) => {
  const { user } = useSelector((state) => state.auth);

  if (!user) {
    return <Navigate to="/error-401" />; // Chưa đăng nhập → chuyển hướng về Login
  }
  const decoded = jwtDecode(user);
  const roleName =
    decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
  if (!allowedRoles.includes(roleName)) {
    return <Navigate to="/error-403" />;
  }

  return children;
};

export default RequireAuth;
